import React from 'react';
import Label from "components/general/Label"
import { ColumnRank, ColumnResult, ColumnName, ColumnNoc, ColumnExtendedResult, ColumnExpander } from 'components/common/TableColumns';
import { isFencingRR, isFencingBR, isSection } from '../helper/MpnHelpers';
import { getRscObject } from 'helpers/rsc';
import { RscFromStore } from 'helpers/utils';
import SportCode from 'components/common/SportCode';

export function ColumnRankRowSpan({ hasRankEqual = false }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Rank',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderRank',
        columns: [
            ColumnRank({ remove: true, disableSort: true, hasRankEqual: hasRankEqual })
        ]
    }
}

export function ColumnNocRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'NOC',
        headerClassName: "text-start d-none d-md-table-cell w-5 align-middle",
        id: 'HeaderNOC',
        columns: [
            ColumnNoc({ remove: true, disableSort: true })
        ]
    }
}


export function ColumnNameRowSpan({ headerClassName = "text-start align-middle" }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Name',
        headerClassName: headerClassName,
        id: 'HeaderBoat',
        label: "HeaderBoat",
        columns: [ColumnName({ remove: true, disableSort: true })]
    }
}


export function ColumnResultRowSpan({ label = 'HeaderTotalMpPoints', headerClassName = 'text-end w-10  mirs-break-line align-middle' }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Result',
        headerClassName: headerClassName,
        id: 'HeaderResult',
        columns: [
            ColumnResult({ remove: true, disableSort: true, label: label })
        ]
    }
}



export function ColumnRemarksRowSpan({ headerClassName, label = 'HeaderRemarks2' }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Remarks',
        headerClassName: headerClassName,
        id: 'HeaderRemarks',
        columns: [
            ColumnRemarks({ remove: true, disableSort: true, label: label })
        ]
    }
}


export function ColumnRemarks({
    disableSort = true,
    className = 'text-start fw-bold',
    headerClassName = 'text-end w-5 align-middle',
    remove = false,
    label = 'HeaderRemarks'
}) {
    return (
        {
            Header: <Label data={label} />,
            remove: remove,
            accessor: 'recordIndicators',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Remarks',
            Cell: (props) => {
                const row = props.cell.row.original;
                //record
                const record = row?.recordIndicators
                    ? row?.recordIndicators.filter(row => row.ri_order === 1).map((val) => {
                        return ((val.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype)
                    })
                    : '';

                //qualification mark
                const qualified = row?.qualificationMark

                //irm
                const irmCode = row?.resultIrm
                const irmObject = irmCode ? <SportCode discipline={getRscObject(RscFromStore()).discipline} entity='@IRM' code={irmCode} abbr={true} isAddLegend={true} /> : '';
                return (
                    <>
                        <span className='fw-bold'>{qualified}</span>
                        {qualified && record && <span className='ps-2' />}
                        <span className='fw-bold'>{record}</span>
                        {((record && irmObject) || (qualified && irmObject)) && <span className='ps-2' />}
                        <span className='fw-normal'>{irmObject}</span>
                    </>
                );
            }
        }
    )
}

export function ColumnItemRowSpan({ section, label, headerClassName, className }) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: section,
        headerClassName: headerClassName,
        id: 'Header' + section,
        columns: [
            ColumnItem({ remove: true, disableSort: true, section: section, label: label, headerClassName: headerClassName, className: className })
        ]
    }
}

export function ColumnItem({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false,
    label = '',
    section = 'none'
}) {
    return (
        {
            Header: <Label data={label} />,
            remove: remove,
            accessor: 'parcitipant-code',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: section,
            Cell: (props) => {
                const row = props.cell.row.original;
                const item = section === 'RR'
                    ? row?.items?.find(i => isFencingRR(i?.eventUnitCode))
                    : section === 'BR'
                        ? row?.items?.find(i => isFencingBR(i?.eventUnitCode))
                        : row?.items?.find(i => isSection(i?.eventUnitCode, section))

                return <>{item?.resPoints}</>
            }
        }
    )
}

export function ColumnFencingColsSpan({ label = "HeaderFencingPoints", headerClassName }) {
    return {
        headerClassName: headerClassName,
        id: 'HeaderFE',
        Header: <Label data={label} />,
        columns: [
            ColumnItem({ disableSort: true, section: "RR", label: "HeaderRR", headerClassName: "text-center" }),
            ColumnItem({ disableSort: true, section: "BR", label: "HeaderBR", headerClassName: "text-center" })
        ]
    }
}

export function ColumnExpanderRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Expander',
        headerClassName: "text-center expander w-5 align-middle",
        id: 'HeaderExpander',
        columns: [
            ColumnExpander({ remove: true })
        ]
    }
}


//MPNMINDIVID-----------SFNL0001EQ--